export default __webpack_public_path__ + "static/media/light.9b7d3d51.png";